define('presentation/signup/viewModels/signupSchedulingViewModel',[
    'businessServices/signup/signupSessionStore',
    'businessServices/signup/signupWebAppSignIn',
    'common/promises/promiseFactory',
    'constants/signupOnboardingSelectionConstants',
    'presentation/common/window/windowControl',
    'presentation/signup/common/signupNavigationManager',
    'settings/navigationConfiguration'
], function() {
    return function() {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
        const _signupSessionStore = new SignupSessionStoreConstructor();

        const SignupWebAppSignInConstructor = require('businessServices/signup/signupWebAppSignIn');
        const _signupWebAppSignIn = new SignupWebAppSignInConstructor();

        const _i18n = require('i18next');
        const _navigationConfiguration = require('settings/navigationConfiguration');
        const _signupOnboardingSelectionConstants = require('constants/signupOnboardingSelectionConstants');
        const _windowControl = require('presentation/common/window/windowControl');

        const MEETINGS_EMBED_SCRIPT_URL = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
        const MEETINGS_EMBED_SCRIPT_MARKER = 'data-patlive-meetings-embed';

        let _signupNavigationManager = null;

        self.isCompositionComplete = ko.observable(false);
        self.hasLiveReceptionistPackage = ko.observable(false);
        self.onboardingSelection = ko.observable('');
        self.schedulerEmbedUrl = ko.observable('');

        self.headingText = _i18n.t('signupScheduling:headingText');
        self.subtitleText = _i18n.t('signupScheduling:subtitleText');

        self.isContinueToOnboarding = ko.pureComputed(() => {
            return self.hasLiveReceptionistPackage() &&
                self.onboardingSelection() === _signupOnboardingSelectionConstants.both;
        });

        self.nextPageButtonText = ko.pureComputed(() => {
            return self.isContinueToOnboarding() ?
                _i18n.t('signupScheduling:continueToOnboarding') :
                _i18n.t('signupScheduling:continueToAccount');
        });

        self.onContinue = () => {
            if (self.isContinueToOnboarding()) {
                _signupWebAppSignIn.signInToWebApp(_navigationConfiguration.routesById.liveReceptionistOnboardingIdentity.url, false);
                return;
            }

            _signupWebAppSignIn.signInToWebApp(_navigationConfiguration.signupLandingPage, true);
        };

        self.onPrimaryActionClicked = () => {
            return _promiseFactory.deferWithMinimumWait(deferredObject => {
                self.onContinue();
                deferredObject.resolve({ keepSpinning: true });
            });
        };

        const _removeMeetingsEmbedScript = () => {
            const existing = document.querySelectorAll('script[' + MEETINGS_EMBED_SCRIPT_MARKER + ']');
            Array.prototype.forEach.call(existing, (script) => script.parentNode.removeChild(script));
        };

        const _loadMeetingsEmbedScript = () => {
            _removeMeetingsEmbedScript();

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = MEETINGS_EMBED_SCRIPT_URL;
            script.setAttribute(MEETINGS_EMBED_SCRIPT_MARKER, 'true');
            document.body.appendChild(script);
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
            _loadMeetingsEmbedScript();
        };

        self.detached = () => {
            _removeMeetingsEmbedScript();
        };

        self.activate = () => {
            _signupWebAppSignIn.init();

            const SignupNavigationManagerConstructor = require('presentation/signup/common/signupNavigationManager');
            _signupNavigationManager = new SignupNavigationManagerConstructor();
            _signupNavigationManager.init();

            return _initialize();
        };

        const _hasPackage = (packageId) => {
            return packageId !== null && packageId !== undefined && packageId !== "";
        };

        const _initialize = () => {
            _promiseFactory.deferIndefinitely(deferredObject => {
                _signupSessionStore.init();
                _signupSessionStore.getState()
                    .fail(deferredObject.reject)
                    .done(signupSession => {
                        const { signupDocument } = signupSession;
                        const hasLiveReceptionistPackage = _hasPackage(signupDocument.liveReceptionistPackageId);
                        const onboardingSelection = signupSession.onboardingSelection();

                        if (hasLiveReceptionistPackage && !onboardingSelection) {
                            _signupNavigationManager.navigateToSuccessPage();
                            deferredObject.resolve();
                            return;
                        }

                        self.hasLiveReceptionistPackage(hasLiveReceptionistPackage);
                        self.onboardingSelection(onboardingSelection);
                        self.schedulerEmbedUrl(_windowControl.getOnboardingAppointmentUrl() + '?embed=true');
                        deferredObject.resolve();
                    });
            });

            return _promiseFactory.wait();
        };
    };
});

